module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0119.png.a9ef4ef3.jpg";